const calculateGrossMargin = product => {
  const marginPercentage = product?.productPriceSection?.marginPercentage

  if (marginPercentage) return marginPercentage

  const baseValue = product?.productPriceSection?.baseValue
  if (!baseValue) {
    return 0
  }

  const productSuppliers =
    product?.productCompositionSection?.productCostFiles[0]?.productSupplier ||
    []

  const rawMaterialList =
    product?.productCompositionSection?.productCostFiles[0]?.rawMaterialList ||
    []

  let totalSupplierCost = 0

  // Calculate total from productSupplier
  for (let index = 0; index < productSuppliers.length; index++) {
    const supplierCost = productSuppliers[index].cost
    const supplierUnits = productSuppliers[index].units || 0
    totalSupplierCost += supplierCost * supplierUnits
  }

  let totalRawMaterialCost = 0

  // Calculate total from rawMaterialList
  for (let index = 0; index < rawMaterialList.length; index++) {
    const rawMaterialCost = rawMaterialList[index].baseValue
    const rawMaterialQuantity = rawMaterialList[index].quantity || 0
    totalRawMaterialCost += rawMaterialCost * rawMaterialQuantity
  }

  const totalCost = totalSupplierCost + totalRawMaterialCost

  if (totalCost === 0) {
    return 0
  }

  const grossMargin = 1 - totalCost / baseValue
  return grossMargin * 100
}

const calculateAcquisition = product => {
  const productSuppliers =
    product?.productCompositionSection?.productCostFiles[0]?.productSupplier ||
    []

  const rawMaterialList =
    product?.productCompositionSection?.productCostFiles[0]?.rawMaterialList ||
    []

  let totalSupplierCost = 0

  // Calculate total from productSupplier
  for (let index = 0; index < productSuppliers.length; index++) {
    const supplierCost = productSuppliers[index].cost
    const supplierUnits = productSuppliers[index].units || 0
    totalSupplierCost += supplierCost * supplierUnits
  }

  let totalRawMaterialCost = 0

  // Calculate total from rawMaterialList
  for (let index = 0; index < rawMaterialList.length; index++) {
    const rawMaterialCost = rawMaterialList[index].baseValue
    const rawMaterialQuantity = rawMaterialList[index].quantity || 0
    totalRawMaterialCost += rawMaterialCost * rawMaterialQuantity
  }

  return totalSupplierCost + totalRawMaterialCost
}

export const getProductMetrics = product => {
  const lastAcquisition = calculateAcquisition(product)
  const grossMargin = calculateGrossMargin(product)

  const baseValue = product?.productPriceSection?.baseValue
  const otherPrices = product?.productPriceSection?.productPrice || []
  const additionalPrice = otherPrices.find(price => price.currencyId !== 1)

  return {
    lastAcquisition,
    grossMargin,
    baseValue,
    additionalPrice
  }
}
